import PageHeader from '@/components/layout/PageHeader';
import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import dayjs from 'dayjs';
import useSearchList from '@/hooks/useSearchList';
import { SEARCH_ITEM_COL, SEARCH_ITEM_GUTTER } from '@/scripts/config';
import { useGetUserPortQuery } from '@/store/apiSlice';
import {
    Button,
    message,
    InputNumber,
    Typography,
    Popconfirm,
    DatePicker,
    Input,
    Card,
    Space,
    Form,
    Select,
    Col,
    Row,
    Table,
    AutoComplete,
    Modal,
} from 'antd';
import { EditableProTable } from '@ant-design/pro-components';
import { getLabelFromMap, createJsonOptions } from '@/scripts/utils';
import { useGetEndPortQuery, useGetStartPortQuery } from '@/store/apiSlice';
import { Log } from '@icon-park/react';
import Item from 'antd/es/list/Item';
const pageKey = 'GoList'; //页面身份
export default function GoList() {
    const [dataSource, setData] = useState([]);
    const [log, setLog] = useState([]);
    const [count, setCount] = useState(2);
    const [submittingId, setSubmittingId] = useState(null);
    const [disableIds, setDisableIds] = useState([]);
    const { data: UserOptions } = useGetUserPortQuery();
    const [editingKey, setEditingKey] = useState('');
    // const [pageKey, setPageKey] = useState(pageKey);
    const [form] = Form.useForm();
    const [formSearch] = Form.useForm();
    const { data: startPortOptions } = useGetStartPortQuery(1);
    const { data: endPortOptions } = useGetEndPortQuery(1);
    const [deVal, setDeVal] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [batchModalVisible, setBatchModalVisible] = useState(false);
    const [batchForm] = Form.useForm();
    const [tableScrollY, setTableScrollY] = useState(600);
    const DelayOptions = [
        { label: '延迟', value: 3 },
        { label: '延时30S', value: 30 },
        { label: '延时60S', value: 60 },
        { label: '延时120S', value: 120 },
        { label: '延时240S', value: 240 },
        { label: '延时360S', value: 360 },
        { label: '延时600S', value: 600 },
        { label: '延时1200S', value: 1200 },
        { label: '无延时', value: 0 },
    ];
    const IsRunOptions = [
        { label: '关闭', value: -1 },
        { label: '开启', value: 0 },
    ];
    const IsRollOptions = [
        { label: '不翻页', value: 1 },
        { label: '翻一页', value: 2 },
        { label: '翻二页', value: 3 },
        { label: '翻三页', value: 4 },
    ];
    const IsLog = (item) => {
        if (item.early_date) {
            item.early_date = dayjs(item.early_date).format('YYYY-MM-DD');
        }
        if (item.delay_time === 3) {
            item.delay_time = '延迟';
        } else if (item.delay_time === 60) {
            item.delay_time = '延时60S';
        } else if (item.delay_time === 120) {
            item.delay_time = '延时120S';
        } else if (item.delay_time === 240) {
            item.delay_time = '延时240S';
        } else if (item.delay_time === 360) {
            item.delay_time = '延时360S';
        } else if (item.delay_time === 600) {
            item.delay_time = '延时600S';
        } else if (item.delay_time === 1200) {
            item.delay_time = '延时1200S';
        } else if (item.delay_time === 0) {
            item.delay_time = '无延时';
        } else {
            item.delay_time = '';
        }

        if (item.is_run === -1) {
            item.is_run = '关闭';
        } else if (item.is_run === 0) {
            item.is_run = '开启';
        }
    };

    const loading = () => {
        let data = [];
        ajax.get('query/list')
            .then((response) => {
                for (let key in response) {
                    data.push({
                        value: (
                            <a href={response[key]} target="_blank">
                                {key}
                            </a>
                        ),
                        key: key,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });

        ajax.get('/check/go/show')
            .then((response) => {
                // let data = response;
                response.map((item) => {
                    IsLog(item);
                    data.forEach((i) => {
                        if (item.log === i.key) {
                            item.log = i.value;
                        }
                    });
                    return item;
                });
                setData(response);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        loading();
        const updateHeight = () => {
            const windowHeight = window.innerHeight;
            setTableScrollY(windowHeight - 400);
        };
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    // 数据搜索
    const renderSearch = () => {
        let params = formSearch.getFieldsValue();
        let data = [];
        ajax.get('query/list')
            .then((response) => {
                for (let key in response) {
                    data.push({
                        value: (
                            <a href={response[key]} target="_blank">
                                {key}
                            </a>
                        ),
                        key: key,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
        ajax.get('/check/go/show', { params })
            .then((response) => {
                // let data = response;
                if (response) {
                    response.map((item) => {
                        IsLog(item);
                        data.forEach((i) => {
                            if (item.log === i.key) {
                                item.log = i.value;
                            }
                        });
                        return item;
                    });
                    setData(response);
                } else {
                    const response = [];
                    setData(response);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    // 获取多选的id
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 多选
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 50,
    };
    // 批量修改弹框提交
    const handleBatchUpdate = async () => {
        try {
            const values = await batchForm.validateFields();
            // 请求参数，ids后面加
            const params = { ids: selectedRowKeys.join(', ') };

            // 起始港
            if (values.origincity_name !== undefined && values.origincity_name !== null && values.origincity_name !== '') {
                params.origincity_name = values.origincity_name;
            }
            // 目的港
            if (values.destinationcity_name !== undefined && values.destinationcity_name !== null && values.destinationcity_name !== '') {
                params.destinationcity_name = values.destinationcity_name;
            }

            // 箱型
            if (values.box_type !== undefined && values.box_type !== null && values.box_type !== '') {
                params.box_type = values.box_type;
            }
            // 延迟时间（文本转数值）
            if (values.delay_time !== undefined && values.delay_time !== null && values.delay_time !== '') {
                const found = DelayOptions.find((opt) => opt.label === values.delay_time);
                params.delay_time = found ? found.value : values.delay_time;
            }
            // 开航时间
            if (values.early_date !== undefined && values.early_date !== null && values.early_date !== '') {
                params.early_date = dayjs(values.early_date).format('YYYY-MM-DD');
            }
            // 目的港类型
            if (
                values.destination_service_mode !== undefined &&
                values.destination_service_mode !== null &&
                values.destination_service_mode !== ''
            ) {
                params.destination_service_mode = values.destination_service_mode;
            }
            // 限价
            if (values.limit_price !== undefined && values.limit_price !== null && values.limit_price !== '') {
                params.limit_price = values.limit_price;
            }
            // 是否开启（文本转数值）
            if (values.is_run !== undefined && values.is_run !== null && values.is_run !== '') {
                const found = IsRunOptions.find((opt) => opt.label === values.is_run);
                params.is_run = found ? found.value : values.is_run;
            }
            // 是否翻页（文本转数值）
            if (values.is_roll !== undefined && values.is_roll !== null && values.is_roll !== '') {
                const found = IsRollOptions.find((opt) => opt.label === values.is_roll);
                params.is_roll = found ? found.value : values.is_roll;
            }

            // 如果没有选中任何行
            if (selectedRowKeys.length === 0) {
                message.warning('请至少选择一条数据');
                return;
            }

            // 检查是否有实际修改的字段
            const hasModify = Object.keys(params).length > 1; // 除了ids还有别的字段
            if (!hasModify) {
                message.warning('请至少修改一个字段');
                return;
            }

            await ajax.post('/check/update/group', params);
            // console.log(params, 'params');

            message.success('批量修改成功');
            setBatchModalVisible(false);
            batchForm.resetFields();
            setSelectedRowKeys([]);
            renderSearch(); // 刷新列表
        } catch (errInfo) {
            console.log('批量修改校验失败:', errInfo);
            message.error('请正确填写表单');
        }
    };
    const EditableCell = React.memo(
        ({
            editing,
            dataIndex,
            title,
            inputTypeBox,
            inputType,
            inputTypeSelect,
            timeTypeSelect,
            useTypeSelect,
            inputTypeDate,
            record,
            index,
            children,
            ...restProps
        }) => {
            let inputNode;
            if (inputType === 'number') {
                inputNode = <InputNumber style={{ width: '100%' }} />;
            } else if (inputType === 'select') {
                inputNode = (
                    <Select
                        style={{ width: '100%' }}
                        options={createJsonOptions(startPortOptions)}
                        filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                        showSearch
                        allowClear
                    ></Select>
                );
            } else {
                inputNode = <Input style={{ width: '100%' }} />;
            }
            if (inputTypeSelect === 'select') {
                inputNode = (
                    <Select
                        style={{ width: '100%' }}
                        options={createJsonOptions(endPortOptions)}
                        filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                        showSearch
                        allowClear
                    ></Select>
                );
            }
            if (timeTypeSelect === 'select') {
                inputNode = (
                    <AutoComplete
                        style={{ width: '100%' }}
                        options={createJsonOptions([
                            '无延时',
                            '延迟',
                            '延时60S',
                            '延时120S',
                            '延时240S',
                            '延时360S',
                            '延时600S',
                            '延时1200S',
                        ])}
                        showSearch
                        allowClear
                    ></AutoComplete>
                );
            }
            if (inputTypeBox === 'selectBox') {
                inputNode = (
                    <Select
                        style={{ width: '100%' }}
                        options={createJsonOptions(['20', '40', '40NOR', '45'])}
                        showSearch
                        allowClear
                    ></Select>
                );
            }
            if (useTypeSelect === 'select') {
                inputNode = <Select style={{ width: '100%' }} options={createJsonOptions(['关闭', '开启'])} showSearch allowClear></Select>;
            }
            if (inputTypeDate === 'date') {
                inputNode = (
                    <Space direction="vertical">
                        <DatePicker style={{ width: '100%' }} defaultValue={deVal} onChange={onChange} format="YYYY-MM-DD" />
                    </Space>
                );
            }
            return (
                <div {...restProps}>
                    {editing ? (
                        <Form.Item
                            name={dataIndex}
                            style={{
                                margin: 0,
                            }}
                        >
                            {inputNode}
                        </Form.Item>
                    ) : (
                        children
                    )}
                </div>
            );
        },
    );

    const isEditing = (record) => record.id === editingKey;

    const onChange = (val) => {
        form.setFieldsValue({
            early_date: dayjs(val).format('YYYY-MM-DD'),
        });
    };

    const edit = (record) => {
        setDeVal(dayjs(record.early_date));
        form.setFieldsValue({
            id: record.id,
            origincity_name: record.origincity_name,
            destinationcity_name: record.destinationcity_name,
            box_type: record.box_type,
            delay_time: record.delay_time,
            early_date: record.early_date,
            update_time: record.update_time,
            log: record.log,
            ...record,
        });
        setEditingKey(record.id);
    };

    // const cancel = () => {
    //     setEditingKey('');
    // };
    // 保存
    const save = async (id) => {
        try {
            const row = await form.validateFields();
            const newData = [...dataSource];
            const index = newData.findIndex((item) => id === item.id);

            const item = [index];
            newData.splice(index, 1, {
                ...item,
                ...row,
                id: id,
            });

            let params = newData[index];

            if (params.delay_time === '延迟') {
                params.delay_time = 3;
            } else if (params.delay_time === '延时60S') {
                params.delay_time = 60;
            } else if (params.delay_time === '延时120S') {
                params.delay_time = 120;
            } else if (params.delay_time === '延时240S') {
                params.delay_time = 240;
            } else if (params.delay_time === '延时360S') {
                params.delay_time = 360;
            } else if (params.delay_time === '延时600S') {
                params.delay_time = 600;
            } else if (params.delay_time === '延时1200S') {
                params.delay_time = 1200;
            } else if (params.delay_time === '无延时') {
                params.delay_time = 0;
            }

            if (params.is_run === '关闭') {
                params.is_run = -1;
            } else if (params.is_run === '开启') {
                params.is_run = 0;
            }

            if (
                params.origincity_name === undefined ||
                params.origincity_name === null ||
                params.destinationcity_name === undefined ||
                params.destinationcity_name === null ||
                params.box_type === undefined ||
                params.box_type === null ||
                params.delay_time === undefined ||
                params.delay_time === null ||
                // params.origin_service_mode === '' ||
                // params.destination_service_mode === '' ||
                params.early_date === ''
            ) {
                message.error('数据不能为空');
                return;
            } else {
                ajax.post('/check/go/update', params)
                    .then((response) => {
                        // setData(newData);
                        // loading();
                        renderSearch();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            setEditingKey('');
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };
    const getStr = (url, msg) => {
        let params = formSearch.getFieldsValue();
        let str = '';
        for (let i = 0; i < dataSource.length; i++) {
            str += dataSource[i].id + ',';
        }
        str = str.substring(0, str.lastIndexOf(','));
        if (selectedRowKeys.length > 0) {
            ajax.get(`${url}&ids=${selectedRowKeys.toString()}`)
                .then((res) => {
                    setSelectedRowKeys([]);
                    renderSearch();
                    message.success(msg);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            ajax.get(`${url}&ids=${str}`)
                .then((res) => {
                    renderSearch();
                    message.success(msg);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };
    // 开启所有
    const handleOpen = () => {
        // ajax.get('/maersk/go/check/auto?early_date=0')
        //     .then((res) => {
        //         message.success('开启成功');
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
        getStr('/maersk/go/check/auto?early_date=0', '开启成功');
    };

    // 关闭所有
    const handleClose = () => {
        // ajax.get('/maersk/go/check/auto?early_date=-1')
        //     .then((res) => {
        //         message.success('关闭成功');
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
        getStr('/maersk/go/check/auto?early_date=-1', '关闭成功');
    };
    // 一键关闭所有
    const handleCloseAll = () => {
        // console.log('关闭成功');
        ajax.get('/check/auto?early_date=-1')
            .then((res) => {
                setSelectedRowKeys([]);
                message.success('一键关闭成功');
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            // align: 'center',
            width: 80,
            sorter: (a, b) => a?.id - b?.id,
        },
        {
            title: '起始港',
            dataIndex: 'origincity_name',
            // align: 'center',
            width: 120,
            editable: true,
            sorter: (a, b) => a['origincity_name'].localeCompare(b['origincity_name']),
        },
        {
            title: '目的港',
            dataIndex: 'destinationcity_name',
            // align: 'center',
            width: 180,
            sorter: (a, b) => a['destinationcity_name'].localeCompare(b['destinationcity_name']),
            editable: true,
        },
        {
            title: '箱型',
            dataIndex: 'box_type',
            // align: 'center',
            width: 80,
            editable: true,
            sorter: (a, b) => a?.box_type - b?.box_type,
        },
        {
            title: '延迟时间(秒)',
            dataIndex: 'delay_time',
            // align: 'center',
            width: 100,
            sorter: (a, b) => a['delay_time'].localeCompare(b['delay_time']),
            editable: true,
        },
        {
            title: '是否开启',
            dataIndex: 'is_run',
            // align: 'center',
            width: 100,
            sorter: (a, b) => a['is_run'].localeCompare(b['is_run']),
            editable: true,
        },
        {
            title: '开航时间',
            dataIndex: 'early_date',
            // align: 'center',
            width: 120,
            editable: true,
            sorter: (a, b) => +new Date(a.early_date) - +new Date(b.early_date),
        },
        {
            title: '日志',
            dataIndex: 'log',
            width: 100,
            // align: 'center',
        },
        {
            title: '备注',
            dataIndex: 'tips',
            width: 80,
            editable: true,
            // align: 'center',
        },
        {
            title: '操作',
            width: 80,
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => save(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            保存
                        </Typography.Link>
                        {/* <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a href="#">Cancel</a>
                        </Popconfirm> */}
                    </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        修改
                    </Typography.Link>
                );
            },
        },
    ];

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : col.dataIndex === 'origincity_name' ? 'select' : 'text',
                inputTypeBox: col.dataIndex === 'box_type' ? 'selectBox' : 'text',
                inputTypeSelect: col.dataIndex === 'destinationcity_name' ? 'select' : 'text',
                timeTypeSelect: col.dataIndex === 'delay_time' ? 'select' : 'text',
                useTypeSelect: col.dataIndex === 'is_run' ? 'select' : 'text',
                inputTypeDate: col.dataIndex === 'early_date' ? 'date' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    return (
        <div className="list">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <PageHeader title="GO列表" sticky></PageHeader>
                </div>
                <Col style={{ display: 'flex' }}>
                    <Space style={{ marginRight: '3%' }}>
                        <Popconfirm title="确认" description="确认要一键关闭所有吗?" okText="是" onConfirm={handleCloseAll} cancelText="否">
                            <Button type="primary">一键关闭所有</Button>
                        </Popconfirm>
                    </Space>
                </Col>
            </div>

            <Card className="ax-search-card">
                <Form
                    form={formSearch}
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                    className="formStyle"
                    autoComplete="off"
                >
                    <Row gutter={SEARCH_ITEM_GUTTER} style={{ width: '80%', display: 'flex' }}>
                        <Col style={{ width: '23%' }}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    showSearch
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '26%' }}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                ></Select>
                            </Form.Item>
                        </Col>
                        <Col style={{ width: '8%' }}>
                            <span>
                                <Button onClick={() => renderSearch()} type="primary">
                                    搜索
                                </Button>
                            </span>
                        </Col>
                    </Row>
                    <Col span={4} style={{ display: 'flex', justifyContent: 'space-around' }}>
                        <Popconfirm title="确认" description="确认要开启所有吗?" okText="是" onConfirm={handleOpen} cancelText="否">
                            <Button type="primary">开启所有</Button>
                        </Popconfirm>
                        <Popconfirm title="确认" description="确认要关闭所有吗?" okText="是" onConfirm={handleClose} cancelText="否">
                            <Button type="primary">关闭所有</Button>
                        </Popconfirm>
                    </Col>
                </Form>
            </Card>
            <Form form={form} component={false}>
                <Button
                    type="primary"
                    onClick={() => setBatchModalVisible(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: 8, marginBottom: '10px' }}
                >
                    批量修改
                </Button>
                <Table
                    rowSelection={rowSelection}
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    rowKey={(record) => record.id}
                    bordered
                    virtual
                    dataSource={dataSource}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={false}
                    scroll={{ y: tableScrollY }}
                />
            </Form>
            <Modal
                title="批量修改"
                open={batchModalVisible}
                onOk={handleBatchUpdate}
                onCancel={() => {
                    setBatchModalVisible(false);
                    batchForm.resetFields();
                }}
                okText="确认修改"
                cancelText="取消"
                width={700}
            >
                <Form form={batchForm} layout="vertical">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="起始港" name="origincity_name">
                                <Select
                                    options={createJsonOptions(startPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="目的港" name="destinationcity_name">
                                <Select
                                    options={createJsonOptions(endPortOptions)}
                                    showSearch
                                    filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) === 0}
                                    allowClear
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="箱型" name="box_type">
                                <Select
                                    options={createJsonOptions(['20', '40', '45', '40NOR', '20,45', '20,40', '40,45', '20,40,45'])}
                                    showSearch
                                    allowClear
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="延迟时间" name="delay_time">
                                {/* <Select
                                                                        options={DelayOptions.map((opt) => ({ label: opt.label, value: opt.label }))}
                                                                        showSearch
                                                                        allowClear
                                                                        placeholder=""
                                                                    /> */}
                                <AutoComplete
                                    options={DelayOptions.map((opt) => ({ value: opt.label }))}
                                    allowClear
                                    filterOption={(inputValue, option) =>
                                        option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="开航时间" name="early_date">
                                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" placeholder="" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="目的港类型" name="destination_service_mode">
                                <Select options={createJsonOptions(['CY', 'SD'])} showSearch allowClear placeholder="" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="限价" name="limit_price">
                                <InputNumber style={{ width: '100%' }} placeholder="" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="是否开启" name="is_run">
                                <Select
                                    options={IsRunOptions.map((opt) => ({ label: opt.label, value: opt.label }))}
                                    allowClear
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        {/* <Col span={12}>
                                                                <Form.Item label="数量" name="quantity">
                                                                    <InputNumber style={{ width: '100%' }} placeholder="" />
                                                                </Form.Item>
                                                            </Col> */}
                        <Col span={12}>
                            <Form.Item label="是否翻页" name="is_roll">
                                <Select
                                    options={IsRollOptions.map((opt) => ({ label: opt.label, value: opt.label }))}
                                    allowClear
                                    placeholder=""
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </div>
    );
}
